'use client';

import { Skeleton } from '@castlery/fortress';

export const ProductDyPromotionSkeleton = () => {
  return <Skeleton />;
};
